import { useAppSelector } from '../../core/store/root.store';
import useGetGlobalSelectedTenants from './useGetGlobalSelectedTenants';
import { TenantDevicesAndGroups } from './useGetTenantDevicesAndGroups';

export default function useTenantDeviceGroupIds(
  tenantDevicesAndGroups: TenantDevicesAndGroups,
  updateType: 'osUpdate' | 'wingetUpdate'
): (string | null)[] | null {
  const { tenantDevices, deviceGroups } = tenantDevicesAndGroups;
  const globalTenants = useGetGlobalSelectedTenants();
  const localSelectedTenantsForOS = useAppSelector(state => state.windowsUpdates.localSelectedTenants);
  const localSelectedTenantsForApp = useAppSelector(state => state.wingetUpdates.localSelectedTenants);

  const localSelectedTenants = updateType === 'wingetUpdate' ? localSelectedTenantsForApp : localSelectedTenantsForOS;

  const deviceGroupsWithoutTenant =
    deviceGroups?.filter(group => !group?.tenant?.id && group.zeroTrustId).map(group => group.zeroTrustId as string) ??
    [];

  let newDeviceGroupIds: (string | null)[] | null = null;
  if (localSelectedTenants.length === 0) {
    if (globalTenants.length > 0) {
      newDeviceGroupIds = [];
      if (globalTenants.find(tenant => tenant?.uuid === 'items-without-tenant')) {
        newDeviceGroupIds = [...deviceGroupsWithoutTenant, null];
      }

      tenantDevices
        ?.filter(device =>
          globalTenants
            .filter(tenant => tenant?.uuid !== 'items-without-tenant')
            .find(tenant => tenant?.uuid === device?.group?.tenant?.id)
        )
        .forEach(device => {
          if (
            device.deviceGroupId &&
            newDeviceGroupIds &&
            !newDeviceGroupIds.find(group => group === device.deviceGroupId)
          ) {
            newDeviceGroupIds?.push(device.deviceGroupId);
          }
        });
    }
  }
  if (localSelectedTenants.length > 0) {
    newDeviceGroupIds = [];
    if (localSelectedTenants.find(tenant => tenant?.uuid === 'items-without-tenant')) {
      newDeviceGroupIds = [...deviceGroupsWithoutTenant, null];
    }

    tenantDevices
      ?.filter(device =>
        localSelectedTenants
          .filter(tenant => tenant?.uuid !== 'items-without-tenant')
          .find(tenant => tenant?.uuid === device?.group?.tenant?.id)
      )
      .forEach(device => {
        if (
          device.deviceGroupId &&
          newDeviceGroupIds &&
          !newDeviceGroupIds.find(group => group === device.deviceGroupId)
        ) {
          newDeviceGroupIds?.push(device.deviceGroupId);
        }
      });
  }
  return newDeviceGroupIds;
}
